import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { requestSubscribe } from 'apps/subscriptions/actions/subscriptions';
import SubscribeControls from 'apps/subscriptions/components/fopPartials/SubscribeControls';
import {
  BUTTON_DISABLED, QUANTITY_INPUT, BUTTON,
} from 'apps/subscriptions/components/fopPartials/SubscribeControlsType';
import { DEFAULT_FREQUENCY } from 'apps/subscriptions/components/fopPartials/SubscriptionsFrequencyOptions';

class SubscribeControlsContainer extends PureComponent {
  static propTypes = {
    sku: PropTypes.string.isRequired,
    onSubscribe: PropTypes.func.isRequired,
    frequencyInEditMode: PropTypes.string,
    subscription: PropTypes.shape({
      quantity: PropTypes.number,
      pending: PropTypes.bool,
    }).isRequired,
    isNewDesign: PropTypes.bool,
    forceChooseFrequency: PropTypes.bool,
    isRecommendation: PropTypes.bool,
  };

  getType() {
    const { pending, quantity } = this.props.subscription;

    if (pending) {
      return BUTTON_DISABLED;
    } else if (quantity > 0 || quantity === undefined) {
      return QUANTITY_INPUT;
    }
    return BUTTON;
  }

  render() {
    const {
      sku,
      onSubscribe,
      frequencyInEditMode,
      isNewDesign,
      forceChooseFrequency,
      isRecommendation,
    } = this.props;

    return (
      <SubscribeControls
        sku={sku}
        type={this.getType()}
        onSubscribe={onSubscribe}
        frequency={frequencyInEditMode}
        isNewDesign={isNewDesign}
        forceChooseFrequency={forceChooseFrequency}
        isRecommendation={isRecommendation}
      />
    );
  }
}

export default connect(
  (state, ownProps) => ({
    subscription: get(state, `subscriptions.subscriptionsBySku['${ownProps.sku}']`) || {
      quantity: 0,
      pending: false,
      frequency: DEFAULT_FREQUENCY,
    },
    frequencyInEditMode: get(state, `subscriptions.frequenciesBySkuInEditMode['${ownProps.sku}']`) || DEFAULT_FREQUENCY,
    isNewDesign: state.user.betaFeatures.includes('SUBSCRIPTIONS_EMPHASIS_FOP'),
    forceChooseFrequency: state.user.betaFeatures.includes('SUBSCRIPTIONS_FORCE_CHOOSE_FREQUENCY'),
  }),
  (dispatch, ownProps) => ({
    onSubscribe: (sku, frequency) => dispatch(requestSubscribe({
      sku,
      frequency,
      collectionFopIdx: ownProps.collectionFopIdx,
      isRecommendation: ownProps.isRecommendation,
    })),
  })
)(SubscribeControlsContainer);
